import { CustomButtonProps } from '@/components/Button/Button';

export const buttonIncreaseProps: CustomButtonProps = {
  variant: 'secondary',
};
